import * as React from 'react';
import { ItemFieldProps } from './types';
import { Field, getValue } from './field';

export const DaysInWorkflowField = ({ item, fieldInfo }: ItemFieldProps) => {
  const fieldTitle = fieldInfo?.schemaField?.displayName;

  const value = getValue(item, fieldInfo?.schemaField);

  if (value === null || value === undefined) return null;

  return (
    <Field fieldInfo={fieldInfo}>
      <span className="workflow-days" title={fieldTitle}>
        {value} Days
      </span>
    </Field>
  );
};
